import React, { useEffect, useState } from 'react';
import Lottie from 'lottie-react';
import '../UploadForm.css';
import TreeIcon1 from '../../assets/animations/tree_json1.json';

function ProcessingAnimation({ isLoading, currentCyclingIcon, showSmall = false }) {
  const [trees, setTrees] = useState([]);

  useEffect(() => {
    if (!isLoading || !currentCyclingIcon || showSmall) return;
    let timeoutId;

    const spawnTree = () => {
      const minTop = 50;
      const maxTop = 70;
      const verticalPos = minTop + Math.random() * (maxTop - minTop);
      const size = 100 + ((maxTop - verticalPos) / (maxTop - minTop)) * 70;
      const newTree = {
        id: Date.now() + Math.random(),
        top: `${verticalPos}%`,
        size: `${size}px`,
        delay: `${Math.random() * 0.5}s`,
        speed: `${15 + (verticalPos / maxTop) * 10}s`,
        opacity: 0.7 + ((verticalPos - minTop) / (maxTop - minTop)) * 0.3,
      };
      setTrees((prev) => [...prev, newTree]);
      const nextDelay = 2000 + Math.random() * 3000;
      timeoutId = setTimeout(spawnTree, nextDelay);
      setTimeout(() => {
        setTrees((prev) => prev.filter((t) => t.id !== newTree.id));
      }, 15000);
    };

    const initialDelay = 50 + Math.random() * 75;
    timeoutId = setTimeout(spawnTree, initialDelay);
    return () => clearTimeout(timeoutId);
  }, [isLoading, currentCyclingIcon, showSmall]);

  if (!isLoading || !currentCyclingIcon) return null;

  if (showSmall) {
    return (
      <div className="lottie-container">
        <Lottie animationData={currentCyclingIcon} loop={true} />
      </div>
    );
  }

  return (
    <div className="animation-container">
      <div id="lottie-container-large">
        <Lottie animationData={currentCyclingIcon} loop={true} />
      </div>
      <div className="tree-track">
        {trees.map((tree) => (
          <div
            key={tree.id}
            className="tree-container"
            style={{
              top: tree.top,
              width: tree.size,
              height: tree.size,
              opacity: tree.opacity,
              animation: `treeEnter 1s ease-out forwards, treeExit ${tree.speed} linear 1s forwards`,
              animationDelay: tree.delay,
              transform: 'translateX(0) scale(0.9)',
              transformOrigin: 'center bottom',
            }}
          >
            <Lottie animationData={TreeIcon1} loop={false} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default ProcessingAnimation;


